import { Component, AfterViewInit, OnInit } from "@angular/core";
import * as Chart from "chart.js";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../../../core/auth/auth.service";
import { UserService } from "../../../../core/user.service";
import { count } from "rxjs/operator/count";
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";

@Component({
  selector: 'app-cqmns-rca-frequency-report',
  templateUrl: './cqmns-rca-frequency-report.component.html',
  styleUrls: ['./cqmns-rca-frequency-report.component.css']
})
export class CqmnsRcaFrequencyReportComponent implements OnInit {
  frequencyCanvas: any;
  frequencyCtx: any;
  myTrend: any;
  classifications = [];
  noOfClassifications = [];
  results: any;
  userId: any;
  projectId: any;
  classes: any;
  headers = new HttpHeaders();
  hostUrl;
  fromDate =
    this.addMonths(new Date(), -6)
      .toISOString()
      .substring(0, 10) + " 00:00:00";
  toDate = new Date().toISOString().substring(0, 10) + " 23:59:59";
  pname: any;
  colors = ['rgba(150,3,3)',
  'rgba(3,66,128)',
  'rgba(100,118,137)',
  'rgba(26,187,156)',
  'rgba(76,208,225)',
  'rgba(255,219,105)',
  'rgba(69,39,160)',
  
 ];
  sources;
  projects: any;
  selectedSource = "J";
  projectName: any;
  project: any;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService,
    private userService: UserService,
    private matDialog: MatDialog
  ) {}

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
  //  this.projectId = this.route.snapshot.params["projectId"];
  this.userId = localStorage.getItem("userid");
  this.projectId = localStorage.getItem("projectId");
  this.projectName = localStorage.getItem("cqm-project-name");
    this.hostUrl = this.userService.getUrl();
    this.http
    .get(
      encodeURI(
        this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
      )
    )
    .subscribe(data => {
      this.project = data;
      for (let i = 0; i <= this.project.length; i++) {
        if(this.project[i]){
        this.projectName = this.project[i].project_name;
        }
      }
    });
    this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/rcaClassificationCount/" + this.projectId
        )
      )
      .subscribe(data => {
        for (const k in data) {
          if (k !== "null") {
            this.classifications.push(k);
            this.noOfClassifications.push(data[k] ? data[k] : 0);
          }
        }
        this.http
          .post(
            encodeURI(
              this.hostUrl + "/api/issue/rcaProjectName/" + this.projectId
            ),
            updateBody,
            { headers: this.headers }
          )
          .subscribe(data => {
            this.results = data;
            this.pname = this.results[0].TESTPROJECT_NAME;
            this.updateChart(this.myTrend);
          });
      });
    this.headers = this.headers.append("Content-Type", "application/json");
    const updateBody = { from: this.fromDate, to: this.toDate };
  }

  addUser(data) {
    this.userId = data.user_id;
  }

  ngAfterViewInit() {
    Chart.defaults.global.defaultFontColor = "#000";
    this.frequencyCanvas = document.getElementById("myTrend");
    this.frequencyCtx = this.frequencyCanvas.getContext("2d");
    this.myTrend = new Chart(this.frequencyCtx, {
      type: "bar",
      data: {
        labels: [],
        datasets: []
      },
      options: {
        legend: {
          display: false,
          position: "right"
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
            },
            scaleLabel: {
              display: true,
              labelString: 'Project Name',
              fontFamily: 'verdana',
              fontSize: 12
            },
            }
          ],
          yAxes: [
            {
              gridLines: {
                display:true
             },
             scaleLabel: {
               display: true,
               labelString: 'Root Cause Count',
               fontFamily: 'verdana',
               fontSize: 12,
              
             },
                 ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }
          ]
        },
        responsive: true,
        display: true,
        maintainAspectRatio: false
      }
    });
  }

  updateChart(myTrend) {
    myTrend.data.datasets = [];
    myTrend.data.labels = [];
    myTrend.update();
    for (let i = 0; i < this.classifications.length; i++) {
      myTrend.data.datasets.push({
        label: this.classifications[i],
        data: new Array(this.results.length).fill(0),
        backgroundColor: this.getColor(i)
      });
    }
    myTrend.update();
    if (this.results !== undefined) {
      for (let i = 0; i < this.results.length; i++) {
        myTrend.data.labels.push(this.pname);
        this.http
          .post(
            encodeURI(
              this.hostUrl + "/api/issue/rcafrequency/" + this.projectId
            ),
            {},
            { headers: this.headers }
          )
          .subscribe(data => {
            for (const j in data) {
              myTrend.update();
              for (let k = 0; k < this.myTrend.data.datasets.length; k++) {
                myTrend.update();

                if (data[j].rootcause === this.myTrend.data.datasets[k].label) {
                  myTrend.data.datasets[k].data[i] += data[j]["count"];
                  myTrend.update();
                  break;
                }
              }
            }
          });
      }
      myTrend.update();
    }
  }

  rotate(arr, n) {
    for (let i = 0; i < n; i++) {
      let swap = arr[0];
      for (let j = 0; j < arr.length - 1; j++) {
        arr[j] = arr[j + 1];
      }
      arr[arr.length - 1] = swap;
    }
  }

  getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getColor(num) {
    if (num <= 7) {
      return this.colors[num];
    } else {
      this.getRandomColor();
    }
  }
  addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
  }
  projectPopup() {
    

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.panelClass = "login-modalbox";

    dialogConfig.backdropClass = 'popupBackdropClass';

    dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

    dialogConfig.panelClass = "ns-modalbox";
    dialogConfig.disableClose = false;
    this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-reports/cqmns-rca-frequency-report/cqmns-rca-frequency-report.component.ts